import { useTranslation } from 'react-i18next';
import { colors } from '../../theme/colors';
import spacing from '../../theme/spacing';
import { fontSize } from '../../theme/typography';

const MaximumNumberLocationsButtonContent = () => {
  const { t, i18n } = useTranslation();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        color: colors.textPrimary,
        fontSize: fontSize.md,
      }}
    >
      <div
        style={{
          width: '100%',
          textAlign: 'center',
          padding: spacing.medium,
        }}
      >
        <div
          style={{
            fontSize: fontSize.sm,
            color: colors.textGreyMedium,
          }}
        >
          {t('location.maximumNumberOfLocationsAdded')}
        </div>
        <div style={{ marginTop: spacing.smallMedium, fontWeight: 'bold' }}>
          {t('location.selectLocationsToRemoveButton')}
        </div>
      </div>
    </div>
  );
};

export default MaximumNumberLocationsButtonContent;
